/**
 * Main store function
 */
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { createLogger } from 'redux-logger'

export function configureStore(initialState = {}) {
  // Middleware and store enhancers
  let enhancers;
  // if (process.env.NODE_ENV === 'production') 
  //   enhancers = [
  //     applyMiddleware(thunk)
  //   ]
  // else
  //   enhancers = [
  //     applyMiddleware(thunk, createLogger()),
  //     composeWithDevTools()
  //   ]
  let store;
  if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging') 
    store = createStore(rootReducer, initialState, composeWithDevTools(applyMiddleware(thunk)));
  else 
    store = createStore(rootReducer, initialState, composeWithDevTools(applyMiddleware(thunk, createLogger())));
  // For hot reloading reducers
  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./reducers', () => {
      const nextReducer = require('./reducers').default; // eslint-disable-line global-require
      store.replaceReducer(nextReducer);
    });
  }

  return store;
}



// WEBPACK FOOTER //
// ./client/src/store.js